<script setup>
import { onMounted, reactive, ref, watch } from "vue";
import { useLoaderStore } from "@store/loader";
import PDF from "pdf-vue3";


const loaderStore = useLoaderStore();
let type = ref('');
const openModal = ref(false)
const props = defineProps({
    file: {
        type: Object,
        required: true,
    },
    showModal: {
        type: Boolean,
        default: false
    }

})


const emit = defineEmits(['close'])
watch(() => props.showModal, (current) => {
    checkType()
    if (current === true) {
        openModal.value = true
    } else {
        openModal.value = false
    }


});

watch(openModal, function (current) {
    if (current == false) {
        emit('close', false)
    }

})


const checkType = () => {
    if (['jpg', 'jpeg', 'png'].includes(props.file.ext)) {
        type.value = 'image'
    } else if (props.file.ext === 'html') {
        type.value = 'pdf'
    }
}


</script>

<template>
    <div>
        <div
            class="me-2 text-center"
            v-if="loaderStore.isLoading"
        >
            <font-awesome-icon
                icon="fa-solid fa-spinner"
                spin
            />
        </div>
        <!-- title="File Versions History" you can pass title to el-dialog -->
        <el-dialog
            v-model="openModal"
            :close-on-click-modal="false"
            class="versionModal filePreviewModal"
            :destroy-on-close="true"
        >
            <img
                v-if="file.mime_type == 'image/jpeg' || ['png', 'jpg', 'jpeg', 'svg'].includes(file.ext)"
                :src="file.url"
                class="img-fluid"
            >

            <video
                v-if="file.ext == 'mp4' || file.ext == 'avi' || file.ext == 'mov'"
                ref="videoPlayer"
                controls
                style="width: 100%"
            >
                <source
                    :src="file.url"
                    type="video/mp4"
                >
                Your browser does not support the video tag.
            </video>

            <iframe
                v-if="file.ext == 'docx' || file.ext == 'doc' || file.ext == 'pptx' || file.ext == 'ppt' || file.ext == 'xls' || file.ext == 'xlsx' || file.ext == 'csv' || file.ext == 'html'"
                :src="`https://view.officeapps.live.com/op/embed.aspx?src=${file.url}`"
                style="width: 100%;height:450px"
                frameborder='0'
            >
                This is an embedded
            </iframe>

            <!-- <iframe
                v-if="file.ext == 'pdf'"
                :src="`https://drive.google.com/viewerng/viewer?embedded=true&url=${file.url}#toolbar=0&scrollbar=0`"
                frameBorder="0"
                scrolling="auto"
                style="width: 100%;height:450px"
            ></iframe> -->

            <PDF
                v-if="file.ext == 'pdf'"
                :src="file.url"
            />

            <div v-if="file.ext == 'vsdx'">
                <h3 class="text-center">
                    No Preview Available!
                </h3>
            </div>

        </el-dialog>
    </div>
</template>
